/**
 * 刊登任务拉取：404 表示任务已删除或无权访问，需清理 URL / 本地 meta，避免反复轮询。
 */

import { readMetaMap, setProductMeta } from './platformListingProductMeta';
import { readReceiveMetaMap, setReceiveItemMeta } from './receiveItemProductMeta';

/** @param {unknown} error */
export function isListingJobNotFoundError(error) {
  return Number(error?.status) === 404;
}

/**
 * 清除本地 meta 中对已不存在任务的引用，停止 reconcile 轮询。
 * @param {number|string} jobId
 * @returns {number} 清理条目数
 */
export function clearStaleListingJobMeta(jobId) {
  const jid = Number(jobId);
  if (!Number.isFinite(jid) || jid <= 0) return 0;
  let cleared = 0;

  const productMap = readMetaMap();
  Object.keys(productMap).forEach((id) => {
    const row = productMap[id];
    if (!row || Number(row.listingJobId) !== jid) return;
    setProductMeta(id, {
      listingJobPending: false,
      listingJobId: null,
    });
    cleared += 1;
  });

  const receiveMap = readReceiveMetaMap();
  Object.keys(receiveMap).forEach((id) => {
    const row = receiveMap[id];
    if (!row || Number(row.listingJobId) !== jid) return;
    setReceiveItemMeta(id, {
      listingJobPending: false,
      listingJobId: null,
    });
    cleared += 1;
  });

  return cleared;
}
